/**
 * The Business plan — Uppbeat's top tier, added August 2026 above Pro.
 *
 * Two rules apply to it and to no other plan:
 * - it can change billing period but never downgrade to another plan;
 * - its price is always quoted excluding tax (VAT for UK visitors).
 *
 * Historical note: "Business" was also the pre-2025 name of the plan that is
 * now Pro. Those subscribers were migrated onto the `Pro` role (keeping their
 * original Stripe plan and price), so the `Business` role is unambiguous
 * today and means this tier. See CONTEXT.md for the full plan timeline.
 */

/**
 * `/admin/pricing` title of the Business plan, and its `?plan=` value at
 * checkout. Lowercase; compare with `isBusinessPlanName`.
 */
export const BUSINESS_PLAN_TITLE = 'business';

export const isBusinessPlanName = (planName: string): boolean =>
  planName.toLowerCase() === BUSINESS_PLAN_TITLE;

/** Business is quoted excluding tax, unlike every other plan. Only UK visitors know it as VAT. */
export const taxExclusiveNote = (country?: string): string =>
  country === 'GB' ? 'excl. VAT' : 'excl. tax';
